var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSlackinline = function SvgSlackinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E01E5A",
    d: "M6.35 17.675a2.665 2.665 0 1 1-2.665-2.665H6.35v2.665M7.68 17.675a2.665 2.665 0 0 1 5.33 0v6.66a2.665 2.665 0 1 1-5.33 0v-6.66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#36C5F0",
    d: "M10.345 6.33a2.665 2.665 0 1 1 2.664-2.665V6.33h-2.665M10.344 7.68a2.665 2.665 0 0 1 0 5.33h-6.68a2.665 2.665 0 0 1 0-5.33h6.68"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2EB67D",
    d: "M21.652 10.345a2.665 2.665 0 1 1 2.665 2.665h-2.665v-2.665M20.32 10.344a2.666 2.666 0 0 1-5.329 0v-6.68a2.665 2.665 0 0 1 5.33 0v6.68"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECB22E",
    d: "M17.656 21.67a2.665 2.665 0 1 1-2.665 2.665V21.67h2.665M17.655 20.34a2.665 2.665 0 1 1 0-5.33h6.68a2.665 2.665 0 1 1 0 5.33h-6.68"
  })));
};
export default SvgSlackinline;